import { questionTypeEnum } from '@/components/survey-detail/config/config-wj.js'
import { questionType } from '@dygc/question' // todo

export function getQuestionNo() {
  // this.feikaiArr[0].questionNo = this.feikaiArr[0].groupQuestionKey ? '1-' + this.feikaiArr[0].groupQuestionKey : '1';
  if (this.feikaiArr[0].questionType == questionTypeEnum.ONLY_TEXT) {
    this.feikaiArr[0].questionNo = ''
  } else if (this.feikaiArr[0].groupQuestionKey) {
    this.feikaiArr[0].questionNo = '1-' + this.feikaiArr[0].groupQuestionKey
  } else if (!this.feikaiArr[0].groupQuestionKey) {
    this.feikaiArr[0].questionNo = '1'
  }
  this.feikaiArr.forEach((item, index) => {
    if (this.feikaiArr.length == 1) return
    if (index !== 0) {
      if (!item.groupQuestionKey) {
        if (item.questionType != questionTypeEnum.ONLY_TEXT) {
          if (isPreNo(item, this.feikaiArr)) {
            item.questionNo = (Number(isPreNo(item, this.feikaiArr)) + 1).toString()
          } else {
            item.questionNo = item.groupQuestionKey ? '1-' + item.groupQuestionKey : '1'
          }
        } else {
          item.questionNo = ''
        }
      } else {
        if (item.questionType != questionTypeEnum.ONLY_TEXT) {
          if (item.groupQuestionKey == this.feikaiArr[index - 1].groupQuestionKey) {
            // 如果此条数据groupQuestionKey和前一条相同，前一条questionNo[0]+1+“-”+groupQuestionKey
            if (isPreNo(item, this.feikaiArr)) {
              item.questionNo = Number(isPreNo(item, this.feikaiArr)) + 1 + '-' + item.groupQuestionKey
            } else {
              item.questionNo = item.groupQuestionKey ? '1-' + item.groupQuestionKey : '1'
            }
          } else {
            // 如果如果此条数据groupQuestionKey和前一条不同，最近groupQuestionId不同的一条questionNo[0]+1+“-”+groupQuestionKey
            let res = getColsestDif(item, this.feikaiArr.slice(0, index))
            item.questionNo = res + '-' + item.groupQuestionKey
          }
        } else {
          item.questionNo = ''
        }
      }
    }
  })
}
export function getColsestDif(item, arr) {
  let object = null
  arr.forEach(ite => {
    if (ite.groupQuestionId !== item.groupQuestionId && ite.questionType != questionTypeEnum.ONLY_TEXT) {
      object = ite
    }
  })
  if (object) {
    return Number(object.questionNo.split('-')[0]) + 1
  } else {
    return Number(arr[0].questionNo.split('-')[0])
  }
}
export function isPreNo(item, arr) {
  let str = ''
  for (let i = arr.indexOf(item) - 1; i >= 0; i--) {
    if (arr[i].questionNo) {
      str = String(arr[i].questionNo)
      break
    }
  }
  let array = []
  if (str) {
    array = str.split('-')
    return array[0]
  } else {
    return ''
  }
}
export function getAppendItems(row) {
  let result = []
  if (row.questionDetails?.issue?.append_items?.length) {
    let arr = row.questionDetails.issue.append_items.map(item => {
      return item.from_qid
    })
    result = this.getAppendOptions(arr)
  } else {
  }
  return result
}
export function getAppendOptions(qidArr) {
  let rowMatch = this.feikaiArr.filter(item => qidArr.includes(item.questonId))
  let itemsArr = []
  let issueItems = []
  rowMatch.forEach(item => {
    let items = item.items.map(ele => ele.optionId)
    itemsArr.push(...items)
    issueItems.push(...item.questionDetails.issue.items)
  })
  let resArr = issueItems.filter(itt => {
    if (itemsArr.includes(itt.id)) {
      return itt
    }
  })
  let remainRes = []
  if (itemsArr.length > resArr.length) {
    let set1 = new Set(itemsArr)
    let set2 = new Set(resArr.map(it => it.id))
    let remainderOptionId = []
    for (let item of set1) {
      if (!set2.has(item)) {
        remainderOptionId.push(item)
      }
    }
    remainRes = this.getRemainder(remainderOptionId)
  }
  return [...resArr, ...remainRes]
}
export function getRemainder(remainderOptionId) {
  let type = [
    questionTypeEnum.SINGLE_CHOICE,
    questionTypeEnum.MULTIPLE_CHOICE,
    questionTypeEnum.SINGLE_SELECT,
    questionTypeEnum.MULTIPLE_SELECT
  ]
  let matchArr = this.feikaiArr.filter(item => type.includes(item.questionType))
  let remainderItems = []
  matchArr.forEach(ele => {
    remainderItems.push(...ele.questionDetails.issue.items)
  })
  let resItems = remainderItems.filter(itt => remainderOptionId.includes(itt.id))
  return resItems
}

//省略字符串中间字符的方法
export function ellipsisMiddle(str, frontLen, endLen) {
  let middle = ''
  if (str.length > frontLen + endLen) {
    middle = '***'
  }
  return str.substring(0, frontLen) + middle + str.substring(str.length - endLen)
}
